const services_columns = [
    {text: 'Descrição', width: '73% ', className: 'text-max-sm'},
    {text: 'Valor', width: '27% ', className: 'text-max-sm'}
];

export default services_columns;
